<template>
    <div class="l-alert">
        <i v-if="type" class="material-icons">{{type}}</i><slot></slot>
    </div>
</template>

<script>
export default {
    name: 'LAlert',
    props:{
        type: {
            validator: (v) => {
                return ['info', 'success', 'warning', 'error'].indexOf(v) !== -1
            },
        },
    }
}
</script>

<style>
.l-alert{
    display: flex;
    background-color: rgb(15, 143, 202);
    color: white;
    padding: 16px 20px;
    margin: 10px 5px;
    box-shadow: 0 5px 10px 0px rgba(0, 174, 255, 0.2);
}
.l-alert>i{
    margin-right: 14px;
    user-select: none;
}
</style>